import {
  Business,
  Event,
  Franchise,
  Garage,
  Job,
  Page,
  Post,
  Product,
  Project,
  Service,
} from "../template";

const templates = {
  Business,
  Event,
  Franchise,
  Garage,
  Job,
  Page,
  Post,
  Product,
  Project,
  Service,
};

export const useTemplate = (template: string) => {
  return templates[template];
};
